module.exports = __webpack_public_path__ + "static/logo-1e98750eb1cb32dae0195a1a66303e72.svg";